module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAALVBMVEUAAADN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uRp7X/EAAAADnRSTlMAKIIVcOteRMGY+J0F20+nDjsAAAB5SURBVAjXYwACo7gXBQxgwLju3buXEObRd0DgAGbmgZhvwMx9IOZDMLMPxHwOZuqBmI/BTDkQswHMZAIxBSCm+b17F8gAAcxJ7lCW0b13794qg1hs78AgAawSDJ4AHQOiIWZwwpgTGLhgzAUMfDDmA2Qm41YIK1oAAPyOaZHe+W8lAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_mine.png
// module id = BZWR
// module chunks = 16